import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/core/authentication/services';
import { DefaultLanguageStringsService } from 'app/core/language/services/default-language-strings.service';
import { UserDetailedInterface, UserInterface } from 'app/core/user/models';
import { UserService } from 'app/core/user/services';
import { RecommendationInterface } from 'app/recommendation/models/recommendation.model';
import { RecommendationService } from 'app/recommendation/services/recommendation.service';
import { SiteSupportedLanguageInterface } from 'app/site-settings/models/site-supported-language.model';
import { SiteSettingsService } from 'app/site-settings/services/site-settings.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'cz-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
})
export class RecommendationsComponent implements OnInit, OnDestroy {

  @Input() public recommendationsOpenForUser$: BehaviorSubject<Readonly<RecommendationInterface[]>>;
  @Input() public recommendationsCompletedForUser$: BehaviorSubject<Readonly<RecommendationInterface[]>>;

  public closedRecommendationCount: number = 9;
  public readonly loadMoreIncrement: number = 9;
  public backupLanguageId: number;
  public defaultLanguage: number;
  public cultureCookie: number;
  public loggedInUser: any;
  public supportedlanguage$: BehaviorSubject<SiteSupportedLanguageInterface[]>;
  public detailedUser$: BehaviorSubject<Readonly<UserDetailedInterface>>;
  private destroy$: Subject<boolean> = new Subject();

  constructor(
    public readonly _defaultLanguageService: DefaultLanguageStringsService,
    private readonly _cookieService: CookieService,
    private readonly _userService: UserService,
    private readonly _recommendationService: RecommendationService,
    private _siteSettingsService: SiteSettingsService,
    private _snackBar: MatSnackBar,
    private readonly _authService: AuthService,
    private _translateService: TranslateService,
  ) {
    this.supportedlanguage$ = new BehaviorSubject<SiteSupportedLanguageInterface[]>(undefined);
    this.detailedUser$ = new BehaviorSubject<Readonly<UserDetailedInterface>>(undefined);
  }

  public ngOnInit(): void {
    this._siteSettingsService.loadSiteSupportedLanguage()
      .pipe(takeUntil(this.destroy$))
      .subscribe((languageData: SiteSupportedLanguageInterface[]) => {
        if (!languageData) { return; }
        this.supportedlanguage$.next(languageData);
      });
    this.supportedlanguage$.subscribe((supportedLanguage: SiteSupportedLanguageInterface[]) => {
      if (!supportedLanguage) { return; }
      supportedLanguage.map((language: SiteSupportedLanguageInterface) => {
        if (language.isDefault) {
          this.defaultLanguage = language.languageId;

          this._defaultLanguageService.defaultLanguageCulture = language.culture;
        }
        if (language.isBackupTranslation) {
          this.backupLanguageId = language.languageId;
        }
        if (language.culture === this._cookieService.get('Culture')) {
          this.cultureCookie = language.languageId;
        }
      });
    });
    this._authService.getAuthenticatedUser()
      .pipe(
        takeUntil(this.destroy$))
      .subscribe((authenticatedUser: UserInterface) => {
        if (authenticatedUser === undefined) {
          return;
        }
        this.loggedInUser = authenticatedUser;
      });
    this.getRecommendationEvent();
  }

  ngOnDestroy(): void {
    
  }


  public getRecommendationEvent() {
    this._recommendationService.getMarkAsCompletedEvent().subscribe((res: any) => {
      if (res) {
        this.showSnackBar();
        this.recommendationsCompletedForUser$.next([]);
        this._userService.getDetailedSelectedUser()
          .pipe(takeUntil(this.destroy$))
          .subscribe((detailedUser: UserDetailedInterface) => {
            if (this.detailedUser$.value && this.detailedUser$.value.user.id === detailedUser.user.id) { return; }
            let userId;
            if(window.location.href.includes("system-users/user-details")) {
              userId = detailedUser.user.id;
            } else {
              userId = this.loggedInUser.id;
            }
            this._recommendationService.loadCompletedRecommendationsForUser(userId)
              .pipe(
                takeUntil(this.destroy$))
              .subscribe((recommendationsData: RecommendationInterface[]) => {
                this._recommendationService.setRecommendationValue(null);
                let recommendation: RecommendationInterface = undefined;
                const recommendations: RecommendationInterface[] = [];
                for (const key in recommendationsData) {
                  if (!recommendationsData.hasOwnProperty(key)) { continue; }
                  recommendation = recommendationsData[key];
                  if (recommendation.isComplete && recommendation.subject && (recommendation.subject.id === userId)) {
                    recommendations.push(recommendation);
                  }
                }
                this.recommendationsCompletedForUser$.next(recommendations);
              });
          })

      }
    });
  }

  private showSnackBar(): void {
    this._snackBar.open(this._translateService.instant('$message_retrieving_data'), undefined, {
      duration: 5000,
    });
  }


  public get allShownRecs(): boolean {
    const total: number = this.recommendationsCompletedForUser$.value.length;
    return total <= this.closedRecommendationCount;
  }

  public getVisibleCompletedRecs(): number {
    return this.recommendationsCompletedForUser$.value.length;
  }

  public loadMoreClosedRecs(): void {
    this.closedRecommendationCount += this.loadMoreIncrement;
  }
}
